// extracted by mini-css-extract-plugin
export default {"toggles":"AddMenuItemsSearch_toggles__Bm75P"};